<template>
    <div class="dark-table-wrapper">
        <DataTable
            :value="datasets"
            size="small"
            stripedRows
            class="dark-etapas-table"
        >
            <!-- Coluna Etapa: 30% da largura total -->
            <Column field="label" header="Etapa" style="width:30%">
                <template #body="{ data }">
                    <span class="etapa-label">
                        <span
                            class="etapa-dot"
                            :style="{ background: colorMap[data.label] || '#6b7280' }"
                        ></span>
                        {{ abbreviateEtapa(data.label) }}
                    </span>
                </template>
            </Column>

            <!-- Colunas de data: exibe só DD/MM -->
            <Column
                v-for="(label, idx) in labels"
                :key="idx"
                :header="shortDate(label)"
                bodyClass="text-center"
                headerClass="text-center"
            >
                <template #body="{ data }">
                    {{ data.data[idx] ?? 0 }}
                </template>
            </Column>

            <template #empty>
                <div class="empty-msg">Nenhum dado disponível</div>
            </template>
        </DataTable>
    </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
    name: 'DarkDataTableEtapas',
    components: { DataTable, Column },
    props: {
        labels:   { type: Array,  default: () => [] },
        datasets: { type: Array,  default: () => [] },
        colorMap: { type: Object, default: () => ({}) }
    },
    methods: {
        /**
         * Exibe apenas DD/MM a partir de "22/04/2026" ou "2026-04-22"
         */
        shortDate(label) {
            if (!label) return label;
            const dmY = label.match(/^(\d{2}\/\d{2})\/\d{4}$/);
            if (dmY) return dmY[1];
            const Ymd = label.match(/^\d{4}-(\d{2})-(\d{2})$/);
            if (Ymd) return `${Ymd[2]}/${Ymd[1]}`;
            return label;
        },

        /**
         * Abrevia etapas com nomes longos
         */
        abbreviateEtapa(name) {
            const map = {
                'Aguardando Aprovação': 'Aguardando',
                'Aguardando aprovação': 'Aguardando',
                'aguardando aprovação': 'Aguardando',
            };
            return map[name] ?? name;
        }
    }
}
</script>

<style scoped>
.dark-table-wrapper {
    background: #0d1117;
    border-radius: 8px;
    overflow: hidden;
}

.etapa-label {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #e6edf3;
    font-size: 0.8rem;
    /* permite quebrar linha se necessário */
    white-space: normal;
    word-break: break-word;
}

.etapa-dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
}

.empty-msg {
    text-align: center;
    padding: 1rem;
    color: #6b7280;
    font-size: 0.85rem;
}

/* ── PrimeVue overrides ─────────────────────────────────── */

/* Mata overflow em todos os wrappers internos do PrimeVue */
:deep(.dark-etapas-table),
:deep(.dark-etapas-table .p-datatable-table-container),
:deep(.dark-etapas-table .p-datatable-wrapper) {
    overflow: hidden !important;
}

/* Tabela ocupa 100% e distribui colunas proporcionalmente */
:deep(.dark-etapas-table table) {
    width: 100% !important;
    table-layout: fixed !important;
}

:deep(.dark-etapas-table .p-datatable-thead > tr > th) {
    background: #010409 !important;
    color: #8b949e !important;
    border-bottom: 1px solid #2a2a2a !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.45rem 0.4rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

:deep(.dark-etapas-table .p-datatable-tbody > tr) {
    background: #0d1117 !important;
    color: #c9d1d9 !important;
    font-size: 0.8rem;
    transition: background 0.15s ease;
}

:deep(.dark-etapas-table.p-datatable-striped .p-datatable-tbody > tr.p-row-odd) {
    background: #1a1a1a !important;
}

:deep(.dark-etapas-table .p-datatable-tbody > tr:hover) {
    background: #1c2333 !important;
}

:deep(.dark-etapas-table .p-datatable-tbody > tr > td) {
    border-bottom: 1px solid #2a2a2a !important;
    border-left: none !important;
    border-right: none !important;
    padding: 0.4rem 0.4rem;
    /* sem corte — deixa o texto quebrar */
    overflow: visible;
    white-space: normal;
    word-break: break-word;
}
</style>
